import React, { useEffect, useState, useRef } from 'react';
import Header from 'components/Header';
//import Footer from 'components/Footer';
import Routes from 'containers/Routes';
import { Button } from 'reactstrap';
//import { isTokenValid } from 'utils/api';
import {Link, useHistory, useLocation} from 'react-router-dom';
import { connect } from 'react-redux';
import { refreshTokenAction, logout, setPermissions } from 'redux/modules/auth/action';
import moment from 'moment';
import momentTZ from 'moment-timezone';
//import { loadState } from 'redux/localStorage';
import store from 'redux/configureStore';

const MainPage = (props) => {
    let history = useHistory();
    const location = useLocation();

    const [cookie, setCookie] = useState(true);
    const timerToClear = useRef(false);

    const UpdateToken = () => {
        let auth = store.getState().auth;
        /*if(loadState()) {
            auth = loadState().auth;
        } else {
            auth = props.auth;
        }*/
        if(auth.isAuthenticated) {
            const correctOffset = momentTZ.tz(momentTZ.tz.guess()).utcOffset();
            const finishDate = moment(auth.wsseToken.accessTokenExpiredAt);
            const startDate = moment().utcOffset(-correctOffset);
            const difference = moment.duration(finishDate.diff(startDate)).asMinutes();
            //console.log('Time difference: ', difference);
            if (difference <= 5 && difference > 0) {
                //console.log('Redux: ', props.auth.wsseToken.refreshToken);
                //console.log('LocalStorage: ', loadState().auth.wsseToken.refreshToken);
                props.refreshTokenAction();
            } else if (difference < 1) {
                props.logout();
                history.push('/signin');
            }
        } else {
            props.logout();
            history.push('/signin');
        }
    };

    useEffect(() => {
        let auth = store.getState().auth;
        //fix for incognito mode cuz store.subscribe do not triggers on first page load ???
        /*if(loadState()) {
            auth = loadState().auth;
        } else {
            auth = props.auth;
        }*/


        if (auth.isAuthenticated) {
            props.setPermissions();
            timerToClear.current = setInterval(() => {
                UpdateToken();
            }, 30000);
            const correctOffset = momentTZ.tz(momentTZ.tz.guess()).utcOffset();
            const finishDate = moment(auth.wsseToken.accessTokenExpiredAt);
            const startDate = moment().utcOffset(-correctOffset);
            const difference = moment.duration(finishDate.diff(startDate)).asMinutes();
            if (difference < 1) {
                props.logout();
                history.push('/signin');
            }
            if(location.pathname === '/signin' || location.pathname === '/signup') {
                history.push('/home')
            }
            return () => {
                clearInterval(timerToClear.current);
            };
        }


    }, [props.auth.isAuthenticated]);

    const closeCookie = () => {
        let theDate = new Date();
        let oneYearLater = new Date(theDate.getTime() + 31536000000);
        let expiryDate = oneYearLater.toGMTString();

        document.cookie = `user-agree=true;expires=${expiryDate}`;

        setCookie(false);
    };

    return (
        <div className="app">
            {cookie && !document.cookie.includes('user-agree') && (
                <div className="coockies-modal">
                    <span style={{ fontSize: '15px' }}>
                        We use cookies to ensure that we give you the best experience on our website. 
                        If you continue to use this site we will assume that you are happy with it.
                    </span>
                    <div className="d-flex ml-2">
                        <Button size="sm" className="btn-square btn-info mr-2" onClick={closeCookie}>
                            OK
                        </Button>
                        <a target="_blank" rel="noopener noreferrer" href="https://newsfetch.io/privacy-policy/">
                            <Button size="sm" className="btn-square" style={{ width: '260px' }}>
                                Read more in our Privacy Policy
                            </Button>
                        </a>
                    </div>
                </div>
            )}
            <Header {...props} />
            <div className="main">
                <Routes/>
            </div>
            {/* <Footer /> */}
        </div>
    );
};

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateFromProps,
    { refreshTokenAction, logout, setPermissions }
)(MainPage);
